import { useEffect, useState } from "react";
import { NO_CHAT_FOLDS, type ChatFolds } from "@omnabase/shared";
import { api } from "../../lib/api";
import { useSession } from "../../shell/store";
import type { ChatFoldGroup } from "../../lib/chatRooms";

/** Team chat's folded headings (the queue-and-chat-column round, 2026-11-03, part two): the person's stored state (`me.chatFolds`, kept on
 *  the server so a phone and a desktop agree), folded at once on a click and saved whole (`PATCH …/me/settings { chatFolds }`). The save's
 *  live note brings the person's other tabs along; a failed save puts the heading back and says so. */
export function useChatFolds(): { folds: ChatFolds; onFold: (group: ChatFoldGroup) => void } {
  const { workspace, toast } = useSession();
  const stored = workspace.me.chatFolds ?? NO_CHAT_FOLDS;
  const [folds, setFolds] = useState<ChatFolds>(stored);
  useEffect(() => { setFolds(stored); }, [stored.channels, stored.tickets, stored.dms]); // eslint-disable-line react-hooks/exhaustive-deps
  const onFold = (group: ChatFoldGroup) => {
    const before = folds;
    const next = { ...folds, [group]: !folds[group] };
    setFolds(next);
    api.patch(`/api/v1/w/${workspace.slug}/me/settings`, { chatFolds: next }).catch(() => { setFolds(before); toast("Could not save the column; try again", { kind: "error" }); });
  };
  return { folds, onFold };
}
